import { flatProductList } from './productHelper.mjs';
import extractPageFromPath from '../../state/_utils/pageResponse/extractPageFromPath.mjs';

const routerUrls = {
  conversationTest: '/guide/:uuid/conversationTest',
  details: '/guide/:uuid/details',
  landing: '/guide',
  summary: '/guide/:uuid/summary',
  survey: '/guide/spa/:uuid/:path/:page'
};

const buildPageUrl = ({ type, path, page, uuid }) => {
  switch (type) {
    case 'landing':
      return '/guide';

    case 'survey':
      return `/guide/spa/${uuid}/${path.key}/${page.key}`;

    case 'summary':
      return `/guide/${uuid}/summary`;

    case 'details':
      return `/guide/${uuid}/details`;

    case 'newUser':
      return '/guide?newUser=true';

    case 'conversationTest':
      return window.ignite && window.ignite.isUsingMockService ? '/conversationTest.html' : `/guide/${uuid}/conversationTest`;

    case 'landingWithUser':
      return uuid ? `/guide?userId=${uuid}` : '/guide';

    default:
      return '/guide';
  }
};

const startNewGuide = ({
  user = {},
  shouldClone,
  cloneOnSameDay,
  products,
  params = {},
} = {}) => {
  const uri = buildPageUrl({ type: 'landing' });
  const { uuid, assignment, timestamp } = user;

  const isSameDay = (guideDate) => {
    const today = new Date();
    return (
      guideDate.getFullYear() === today.getFullYear() &&
      guideDate.getMonth() === today.getMonth() &&
      guideDate.getDate() === today.getDate()
    );
  };
  const shouldBeCloned =
    assignment && shouldClone
      ? cloneOnSameDay || !isSameDay(new Date(timestamp))
      : false;

  const searchParams = new URLSearchParams();
  if (shouldBeCloned) {
    searchParams.append('cloneFrom', uuid);
    searchParams.append('AssociateID', assignment.employee.employeeId);
    searchParams.append('BranchID', assignment.branch.clientId);
    searchParams.append(
      'existingProducts',
      (flatProductList(products) || []).map((p) => p.id).join()
    );
  } else if (uuid) {
    searchParams.append('userId', uuid);
  }

  for (const key in params) {
    if (params[key]) {
      searchParams.append(key, params[key]);
    }
  }

  return `${uri}?${searchParams.toString()}`;
};

const isLandingPage = () => {
  return extractPageFromPath(window.location.pathname).type === 'landing';
};

const isDetailsPage = () => {
  return extractPageFromPath(window.location.pathname).type === 'details';
};

const isSummaryPage = () => {
  return extractPageFromPath(window.location.pathname).type === 'summary';
};

const isSurveyPage = () => {
  return extractPageFromPath(window.location.pathname).type === 'survey';
};

export {
  buildPageUrl,
  isLandingPage,
  isDetailsPage,
  isSummaryPage,
  isSurveyPage,
  startNewGuide,
  routerUrls
};
